module.exports = __webpack_public_path__ + "media/images/pc/page_common/icon/icon_search-ec144865ac22ce39ee83e7f1b3023f9c.svg";